import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import action from './action'
Vue.use(Vuex)

const state = {
  login: false,   // 是否登录
  userInfo: null, // 用户信息
  TokenData: null,
  menuList: [],
  PreOrderCount:0,// 预定药片数量
}

export default new Vuex.Store({
  state,
  action,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js